import {RemoteRefundPatchUpdateRequest} from 'data/usecases';
import {PatchRefundUpdateRequest} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePatchRefundUpdateRequest = (protocol: string): PatchRefundUpdateRequest =>
	new RemoteRefundPatchUpdateRequest(
		makeBFFApiUrl(`${RefundFlowEndPoints.protocol}/${protocol}`),
		makeAuthorizeHttpClientDecorator(),
	);
